import { useParams } from 'react-router-dom';
import { Card, Row, Col } from 'react-bootstrap';

const customers = [
  { id: 'c1', name: 'Jane Doe', email: 'jane@example.com', totalOrders: 12, totalSpent: 1240 },
  { id: 'c2', name: 'John Smith', email: 'john@example.com', totalOrders: 7, totalSpent: 580 },
];

export default function CustomerDetail() {
  const { id } = useParams<{ id: string }>();
  const customer = customers.find((item) => item.id === id);

  if (!customer) {
    return <div>Customer not found.</div>;
  }

  return (
    <Card className="shadow-sm">
      <Card.Body>
        <Row>
          <Col>
            <Card.Title>{customer.name}</Card.Title>
            <div>Email: {customer.email}</div>
            <div>Total Orders: {customer.totalOrders}</div>
            <div>Total Spent: ${customer.totalSpent}</div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

